/**
 * @file Contém funções utilitárias para interagir com a área de transferência.
 */

/**
 * Copia um texto para a área de transferência do usuário de forma assíncrona.
 * Utiliza a API `navigator.clipboard` que é moderna e segura.
 *
 * @param {string} text - O texto a ser copiado.
 * @returns {Promise<boolean>} Retorna uma promessa que resolve para `true` se a cópia for bem-sucedida, e `false` caso contrário.
 */
export const copyToClipboard = async (text) => {
    // Verifica se a API do Clipboard está disponível no navegador.
    // Isso garante que o código não quebre em navegadores mais antigos ou em contextos inseguros (não-HTTPS).
    if (!navigator.clipboard) {
        console.error("Clipboard API not available. This feature works best in a secure context (HTTPS).");
        return false;
    }

    try {
        // Tenta escrever o texto na área de transferência.
        await navigator.clipboard.writeText(text);
        // Retorna true para indicar sucesso.
        return true;
    } catch (err) {
        // Em caso de erro (por exemplo, permissão negada pelo usuário), loga o erro e retorna false.
        console.error('Failed to copy text to clipboard: ', err);
        return false;
    }
};
